module.exports = __webpack_public_path__ + "img/cordoba_fall.4da9583e.svg";